module.exports = __webpack_public_path__ + "media/images/salespartner/merit02-de8ebcdec7f2cab1cd1b3e1d7d3a29e1.svg";